import type { MissionObjective } from "@frontier/content/contracts";
import type {
  EscortMissionView,
  EscortTerms,
} from "@frontier/content/escort-contracts";
import "./escort.css";

export function EscortRoutePreview({
  terms,
  name,
  compact = false,
  view,
  objective,
}: {
  terms: EscortTerms;
  name: string;
  compact?: boolean;
  view?: EscortMissionView | null;
  objective?: MissionObjective;
}) {
  const first = terms.path[0];
  const last = terms.path.at(-1);
  if (!first || !last) return null;
  const minX = Math.min(...terms.path.map((point) => point.x));
  const minY = Math.min(...terms.path.map((point) => point.y));
  const width = Math.max(1, ...terms.path.map((point) => point.x - minX));
  const height = Math.max(1, ...terms.path.map((point) => point.y - minY));
  const scale = Math.min(280 / width, 56 / height);
  const offsetX = (320 - width * scale) / 2;
  const offsetY = (80 - height * scale) / 2;
  const project = (point: { x: number; y: number }) => ({
    x: offsetX + (point.x - minX) * scale,
    y: offsetY + (point.y - minY) * scale,
  });
  const start = project(first);
  const finish = project(last);
  const transport =
    view?.transportId && objective?.targetId === view.transportId
      ? project(objective)
      : null;
  return (
    <span className={`escort-route-preview${compact ? " compact" : ""}`}>
      <svg
        viewBox="0 0 320 80"
        role="img"
        aria-label={`Маршрут сопровождения: ${name}`}
        data-escort-route={terms.routeId}
      >
        <polyline
          className="escort-preview-path"
          points={terms.path
            .map((point) => {
              const projected = project(point);
              return `${projected.x},${projected.y}`;
            })
            .join(" ")}
        />
        {terms.path.slice(1, -1).map((point, index) => {
          const projected = project(point);
          return (
            <circle
              key={index}
              cx={projected.x}
              cy={projected.y}
              r="2.5"
              className="escort-preview-waypoint"
            />
          );
        })}
        <circle
          cx={start.x}
          cy={start.y}
          r="5"
          className="escort-preview-start"
        />
        <path
          d={`M${finish.x} ${finish.y - 6}l6 6-6 6-6-6Z`}
          className="escort-preview-finish"
        />
        {transport && (
          <circle
            cx={transport.x}
            cy={transport.y}
            r="5"
            className="escort-preview-transport"
          />
        )}
      </svg>
      {!compact && (
        <span className="escort-route-caption">
          СТАРТ <span>{terms.waves.length} ЗАСАДЫ</span> НАЗНАЧЕНИЕ
        </span>
      )}
    </span>
  );
}
